import { render, staticRenderFns } from "./TemplateGalleryCard.vue?vue&type=template&id=b3e85cf2&scoped=true"
import script from "./TemplateGalleryCard.vue?vue&type=script&lang=js"
export * from "./TemplateGalleryCard.vue?vue&type=script&lang=js"
import style0 from "./TemplateGalleryCard.vue?vue&type=style&index=0&id=b3e85cf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e85cf2",
  null
  
)

export default component.exports